module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<hr />\n<table>\n	<tr>\n		<th>Port</th>\n		<td><input type=\'number\' class=\'field\' placeholder=\'50\' id=\'options.port\' value=\''+
((__t=(options.port))==null?'':__t)+
'\'>\n		</td>\n	</tr>\n</table>';
}
return __p;
};
